import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

export default function SlPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const { hostname, pathname } = window.location;

        // Extract department from subdomain
        const department = hostname.split('.')[0];

        // Extract token from URL path /sl/<token>
        const token = pathname.split('/').pop();

        if (!department || !token) {
            toast.error("Invalid login link.");
            return;
        }

        loginWithShortToken(department, token);
    }, []);

    const loginWithShortToken = async (department, token) => {
        try {
            const body = { department, token };

            // Build dynamic API URL with department as subdomain
            const apiUrl = `https://${department}.firehouse247staging.com/api/v1/loginByShortToken`;

            const res = await axios.post(apiUrl, body);
            const data = res?.data;

            localStorage.setItem("department", department);
            localStorage.setItem("token", data?.token);
            localStorage.setItem("user", JSON.stringify(data?.user));
            localStorage.setItem("permission", JSON.stringify(data?.permission));
            localStorage.setItem("pages", JSON.stringify(data?.allowedPages));
            localStorage.setItem("pagesName", JSON.stringify(data?.PagesNames));
            localStorage.setItem("is_dn_deparment", JSON.stringify(data?.is_dn_deparment));

            toast.success("Login Successful");
            navigate("/firehouse/accept-shifts");
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || error.message);
        }
    };

    return (
        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: '100vh', width: '100%' }}>
            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} alt="logo" />
            <span className='mt-4' style={{ color: '#555555' }}>
                Redirecting...
            </span>
        </div>
    );
}
